import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cascader = _resolveComponent("Cascader")!

  return (_openBlock(), _createBlock(_component_Cascader, {
    value: _ctx.formState.terminalCategory,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.terminalCategory) = $event)),
    options: _ctx.options,
    placeholder: "请选择...",
    "load-data": _ctx.loadData,
    "change-on-select": "",
    onBlur: _ctx.blurRegionValue
  }, null, 8, ["value", "options", "load-data", "onBlur"]))
}